module.exports = __webpack_public_path__ + "../resources/img/bg_pv2_03.b7f5beb3.png";